import { toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1fee63a2")

_pushScopeId("data-v-1fee63a2")
const _hoisted_1 = { class: "calendar-picker-root" }
const _hoisted_2 = { class: "wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_v_date_picker, {
      class: "vc",
      modelValue: _ctx.date,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.date = $event)),
      mode: "date",
      "is-dark": "",
      color: "gray",
      locale: "zh",
      attributes: _ctx.attrs,
      "min-date": _ctx.minDate,
      disabled: ""
    }, {
      default: _withId(({ inputValue, inputEvents }) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("input", _mergeProps({ value: inputValue }, _toHandlers(inputEvents), {
            class: "input",
            placeholder: _ctx.placeHolder,
            disabled: !_ctx.enabled,
            readonly: "readonly"
          }), null, 16, ["value", "placeholder", "disabled"]),
          _createVNode("span", {
            class: "icon icon-calendar",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFocus && _ctx.setFocus(...args)))
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "attributes", "min-date"])
  ]))
})